import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMountEffect } from '@react-hookz/web';
import { Breakpoint, useConfiguration } from '@travel-frontend/core';
import { useTranslation } from 'react-i18next';
import { CountrySwitchDesktop, CountrySwitchMobile } from '../../components/CountrySwitch/index.js';
import { BottomBar } from '../../components/Header/components/BottomBar/index.js';
import { ControlsContainer } from '../../components/Header/components/ControlsContainer.js';
import { DesktopMenu } from '../../components/Header/components/DesktopMenu/index.js';
import { MainContainer } from '../../components/Header/components/MainContainer/index.js';
import { TopBar } from '../../components/Header/components/TopBar/index.js';
import { AccessibilityToggle } from '../../components/Header/components/TopBar/AccessibilityToggle.js';
import { useHeaderHandlers } from '../../components/Header/context/index.js';
import { LoginControlWrapper } from '../../components/Header/wrappers/LoginControlWrapper.js';
import { HeaderFavorite } from '../../components/HeaderFavorite/index.js';
import { HotlineBarContent } from '../../components/HotlineBarNew/HotlineBarContent.js';
import LogoSection from '../../components/LogoSection/index.js';
import { MobileMenu } from '../../components/MobileMenu/index.js';
import { SslWidget } from '../../components/SslWidget/index.js';
import { useAuthentication } from '../../hooks/index.js';
export const Header = ({
  config,
  path = '',
  pageTitle = '',
  onAccessibilityToggle
}) => {
  const {
    getUserStatus
  } = useAuthentication();
  const {
    t
  } = useTranslation('headerNew');
  const brandName = useConfiguration('brandName');
  const {
    onFavoriteClick
  } = useHeaderHandlers();
  useMountEffect(() => {
    getUserStatus();
  });
  return _jsxs(MainContainer, {
    children: [_jsx(TopBar, {
      accessibilityToggle: config?.accessibilityToggleEnabled && onAccessibilityToggle && _jsx(AccessibilityToggle, {
        handleAccessibilityToggleClick: onAccessibilityToggle
      }),
      controls: _jsxs(ControlsContainer, {
        children: [_jsx(Breakpoint, {
          matches: ['sm', 'xs'],
          children: config?.hotline && _jsx(HotlineBarContent, {
            config: config.hotline,
            dropdownPlacement: "bottom"
          })
        }), _jsxs(Breakpoint, {
          matches: ['lg', 'xl'],
          children: [config?.countrySwitch && _jsx(CountrySwitchDesktop, {
            countrySwitchData: config.countrySwitch
          }), config?.favouriteList && _jsx(HeaderFavorite, {
            onClick: onFavoriteClick,
            withCaption: true
          }), config?.login && _jsx(LoginControlWrapper, {
            config: config,
            withCaption: true
          })]
        }), _jsxs(Breakpoint, {
          matches: ['md', 'sm', 'xs'],
          children: [config?.favouriteList && _jsx(HeaderFavorite, {
            onClick: onFavoriteClick
          }), config?.login && _jsx(LoginControlWrapper, {
            config: config
          })]
        })]
      }),
      children: config?.hotline && _jsx(Breakpoint, {
        matches: ['lg', 'xl', 'md'],
        children: _jsx(HotlineBarContent, {
          config: config.hotline,
          dropdownPlacement: "bottom"
        })
      })
    }), _jsxs(BottomBar, {
      pageTitle: config?.menu ? undefined : pageTitle,
      logo: config && _jsx(LogoSection, {
        "aria-label": t('logoAriaLabel', {
          brandName
        }),
        logoConfig: config.logo,
        pageType: config.pageType,
        path: path
      }),
      children: [_jsxs(Breakpoint, {
        matches: ['lg', 'xl'],
        children: [config?.menu?.items && _jsx(DesktopMenu, {
          menuItems: config.menu.items
        }), !config?.menu && config?.sslIcon && _jsx(SslWidget, {})]
      }), _jsx(Breakpoint, {
        matches: ['md', 'sm', 'xs'],
        children: _jsxs(ControlsContainer, {
          children: [config?.menu && _jsx(MobileMenu, {
            config: config.menu.items,
            additionalItems: config.countrySwitch && _jsx(CountrySwitchMobile, {
              countrySwitchData: config.countrySwitch
            })
          }), config?.sslIcon && _jsx(SslWidget, {})]
        })
      })]
    })]
  });
};